import { defineComponent as _defineComponent } from 'vue'
import TBadge from '~/components/atoms/t-badge.vue';

interface Props {
  filters: Record<string, string[]>;
}
interface Emits {
  (event: 'removeFilter', key: string, value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPills',
  props: {
    filters: null
  },
  emits: ["removeFilter"],
  setup(__props: any) {

const filterText = (valueKey: string, value: string) => {
  if (valueKey.includes('lvl1')) {
    return value.split(' > ')[1];
  }
  return value;
};




return { __sfc: true,filterText, TBadge }
}

})